// features/common/toasterSlice.ts
import { createSlice } from '@reduxjs/toolkit';
const initialState = {
    open: false,
    message: '',
    severity: 'info',
};
const toasterSlice = createSlice({
    name: 'toaster',
    initialState,
    reducers: {
        showToast: (state, action) => {
            state.open = true;
            state.message = action.payload.message;
            state.severity = action.payload.severity;
        },
        hideToast: (state) => {
            state.open = false;
            state.message = '';
        },
    },
});
export const { showToast, hideToast } = toasterSlice.actions;
export default toasterSlice.reducer;
